<script>
  import {onMount} from "svelte";
  import {PHP} from "../store";
  import {fetchUpgradeData} from "../api";

  let forceClose = false;
  let upgradeData = {};

  onMount(async () => {
    if ($PHP.isActivated) upgradeData = (await fetchUpgradeData()).data || {};
  });
</script>

<style>
  .wrapper {
    margin: 10px 0;
  }

  p {
    color: #333333;
    font-weight: bold;
  }

  a.button {
    margin-left: 10px;
  }
</style>

{#if upgradeData.shouldUpgrade && !forceClose}
  <div class="wrapper container is-fluid">
    <div class="notification is-danger">
      <button class="delete" on:click={() => (forceClose = true)}/>
      <p>
        {upgradeData.text || ""}
        <a
          class="button is-inverted is-outlined"
          href={upgradeData.link}>
          Click here to upgrade
        </a>
      </p>
    </div>
  </div>
{/if}
